import type { FC } from 'react'
import IconButton from '@mui/material/IconButton'
import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { Close } from '@dhl/icons'

type Props = {
  onClose: () => void
}

export const Header: FC<Props> = ({ onClose }) => {
  const { t } = useTranslation()

  return (
    <Box display="flex" width={300}>
      <Typography variant="h4" p="20px">
        {t('widgets.whatsnew.title')}
      </Typography>
      <IconButton
        aria-label={t('close')}
        data-test="close-whats-new-drawer"
        size="large"
        sx={{
          padding: 0,
          marginBottom: 1,
          marginLeft: 4,
          marginRight: 0.25,
        }}
        onClick={onClose}
      >
        <Close sx={{ color: 'grey.300' }} />
      </IconButton>
    </Box>
  )
}
